import React, { createContext, useState } from "react";

import { User } from "../models/user";

interface UserContextProps {
  users?: User[];
  user?: User;
  isOnProfilePage?: boolean;
  isOnContactModal?: boolean;
  setIsOnProfilePage: (value: boolean) => void;
  setIsOnContactModal: (value: boolean) => void;
  setUsers?: (users: User[]) => void;
  handleUpdateUser?: (user: User) => void;
}

const UserContext = createContext<UserContextProps>({} as UserContextProps);

interface UserProviderProps {
  children: React.ReactChild;
}

const UserProvider = ({ children }: UserProviderProps) => {
  const [users, setUsers] = useState<User[]>([]);
  const [user, setUser] = useState<User>();
  const [isOnProfilePage, setIsOnProfilePage] = useState<boolean>(false);
  const [isOnContactModal, setIsOnContactModal] = useState<boolean>(false);

  const handleUpdateUser = (user: User) => {
    if (user) setUser((state) => (state ? { ...state, ...user } : { ...user }));
  };

  return (
    <UserContext.Provider
      value={{
        users,
        user,
        isOnProfilePage,
        isOnContactModal,
        setIsOnProfilePage,
        setIsOnContactModal,
        handleUpdateUser,
        setUsers,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
